// extracted by mini-css-extract-plugin
export var notice = "notice-module--notice--Bd1LB";
export var noticeList = "notice-module--notice-list--1z_0V";
export var noticeText = "notice-module--notice-text--2VJu0";
export var noticeDate = "notice-module--notice-date--3cy0A";
export var noticeMore = "notice-module--notice-more--jy9AO";
export var btnPlus = "notice-module--btn-plus--3SFNq";
export var moreText = "notice-module--more-text--2T9Jc";